module.exports = __webpack_public_path__ + "img/childs-2.cb5437c6.png";